import apiClient from '../../../services/apiClient';

export const timetableApi = {
  getTimetables: async (schoolId) => {
    const response = await apiClient.get(`/schools/${schoolId}/timetable/`);
    return response.data.data || response.data;
  },

  createTimetable: async (schoolId, data) => {
    const response = await apiClient.post(`/schools/${schoolId}/timetable/create/`, data);
    return response.data.data || response.data;
  },

  getPeriods: async (schoolId) => {
    const response = await apiClient.get(`/schools/${schoolId}/timetable/periods/`);
    return response.data.data || response.data;
  },

  createPeriod: async (schoolId, data) => {
    const response = await apiClient.post(`/schools/${schoolId}/timetable/periods/create/`, data);
    return response.data.data || response.data;
  },

  updatePeriod: async (schoolId, periodId, data) => {
    const response = await apiClient.patch(`/schools/${schoolId}/timetable/periods/${periodId}/update/`, data);
    return response.data.data || response.data;
  },

  bulkCreateSlots: async (schoolId, timetableId, data) => {
    const response = await apiClient.post(`/schools/${schoolId}/timetable/${timetableId}/slots/bulk-create/`, data);
    return response.data.data || response.data;
  }
};
